import {SetPostUpdateStatus} from './thunk/setPostUpdateStatus';
import {SetGetUpdateGame} from './thunk/setGetUpdateGame';
import {SetGetProviderList} from './thunk/setGetProviderList';
import {SetGetSearchList} from './thunk/setGetSearchList';

export const Thunks = {
    SetGetProviderList,
    SetGetSearchList,
    SetGetUpdateGame,
    SetPostUpdateStatus
}